import React from 'react';
// import { Icon, Header, Image, Form, Message } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';
import { getProfile } from '../actions/access.actions';
import { connect } from 'react-redux';
import { login, register, logout } from '../actions/access.actions';
import toggleLogin from '../actions/modals.actions';
import * as Yup from 'yup';
// import { FormGroup } from '@mui/material/colors';
import GoogleIcon from '@mui/icons-material/Google';
import { FormikCheckbox, FormikInputMUI } from '../components/FormikInput';
import { Link } from 'react-router-dom';
// eslint-disable-next-line
//import styled from 'styled-components/macro';
import { post } from '../util/api';
import { Formik } from 'formik';
import { Box, Button, Container, Grid, Typography, Alert, AlertTitle } from '@mui/material';

const RegisterFormValidation = Yup.object().shape({
	email: Yup.string().email('E-mail is not valid!').required('E-mail is required!'),
	password: Yup.string()
		.required('Password is required!')
		.matches(
			/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/,
			'Min 8, at least one uppercase, lowercase, number and special.'
		),
	passwordConfirmation: Yup.string()
		.oneOf([Yup.ref('password')], 'Passwords are not the same!')
		.required('Password confirmation is required!'),
	consent: Yup.bool()
		.test('consent', 'You have to agree with our Terms and Conditions!', (value) => value === true)
		.required('You have to agree with our Terms and Conditions!'),
});

const LoginFormValidation = Yup.object().shape({
	email: Yup.string().email('E-mail is not valid!').required('E-mail is required!'),
	password: Yup.string().min(6, 'Password has to be longer than 6 characters!').required('Password is required!'),
});

const ForgotFormValidation = Yup.object().shape({
	email: Yup.string().email('E-mail is not valid!').required('E-mail is required!'),
});
const ResetFormValidation = Yup.object().shape({
	password: Yup.string()
		.required('Password is required!')
		.matches(
			/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/,
			'Min 8, at least one uppercase, lowercase, number and special.'
		),
	passwordConfirmation: Yup.string()
		.oneOf([Yup.ref('password')], 'Passwords are not the same!')
		.required('Password confirmation is required!'),
});
/* 
const preState = props => (
	<pre
		css={`
			position: absolute;
			bottom: 0;
			left: 100px;
			right: 0;
			background: white;
			border: 1px solid red;
			margin: 0;
		`}
	>
		{JSON.stringify(props, null, 2)}
	</pre>
); */

// const RegisterForm = (props) => {
// 	if (props.userObj && props.userObj.isAuthenticated) return <Redirect to={{ pathname: '/settings/subscription' }} />;
// 	return (
// 		<div
// 			css={`
// 				margin-left: 20px;
// 				margin-right: 20px;
// 				display: flex;
// 				height: 100%;
// 				align-items: center;
// 				justify-content: center;
// 			`}
// 		>
// 			<div
// 				css={`
// 					max-width: 100%;
// 					width: 450px;
// 					.ui.header {
// 						margin-top: 10px !important;
// 						padding: 12px;
// 					}
// 				`}
// 			>
// 				<Button as={Link} to="/login" color="teal" compact>
// 					<Icon name="arrow left" />
// 					Go to Login Page
// 				</Button>
// 				<Header as="h2" textAlign="center">
// 					<div>Register Page</div>
// 					<Image src="/maytapi.svg" style={{ width: '6rem', margin: '10px' }} />
// 					<div style={{ fontSize: '18px' }}>
// 						<p style={{ margin: 0 }}>Maytapi</p>
// 					</div>
// 				</Header>
// 				{props.error && (
// 					<Message error header={'The mail already used.'}>
// 						<p>
// 							If you forget your password.
// 							<Link to="/login">You can reset Password.</Link>
// 						</p>
// 					</Message>
// 				)}
// 				<Formik
// 					initialValues={{ email: '', password: '', passwordConfirmation: '', consent: false }}
// 					validationSchema={RegisterFormValidation}
// 					onSubmit={(values) => props.registerUser(values.email, values.password)}
// 					render={(state) => {
// 						return (
// 							<Form onSubmit={state.handleSubmit}>
// 								<TrimmedFormikInput label="Work Email" name="email" iconPosition="left" icon="mail" placeholder="user@mail.com" />
// 								<FormikInput label="Password" name="password" iconPosition="left" icon="lock" placeholder="Password" type="password" />
// 								<FormikInput
// 									label="Confirm Password"
// 									name="passwordConfirmation"
// 									iconPosition="left"
// 									icon="lock"
// 									placeholder="Confirm Password"
// 									type="password"
// 								/>
// 								<FormikCheckbox
// 									label={
// 										<label>
// 											I agree to the{' '}
// 											<a target="_blank" rel="noopener noreferrer" href="https://maytapi.com/legal/terms" pass>
// 												Terms of Service
// 											</a>{' '}
// 											and{' '}
// 											<a target="_blank" rel="noopener noreferrer" href="https://maytapi.com/legal/privacy">
// 												Privacy Policy
// 											</a>
// 										</label>
// 									}
// 									name="consent"
// 								/>
// 								<Button primary fluid type="submit">
// 									Register
// 								</Button>
// 								{/*
// 								<pre>{JSON.stringify(state, null, 2)}</pre> */}
// 							</Form>
// 						);
// 					}}
// 				/>
// 			</div>
// 		</div>
// 	);
// };

const RegisterForm = (props) => {
	if (props.userObj && props.userObj.isAuthenticated) return <Redirect to={{ pathname: '/subscription' }} />;
	return (
		<>
			<Box
				component="main"
				sx={{
					alignItems: 'center',
					display: 'flex',
					flexGrow: 1,
					minHeight: '100%',
				}}
			>
				<Container maxWidth="sm">
					{/* {props.error && (
						<Message error header={'The mail already used.'}>
							<p>
								If you forget your password.
								<Link to="/login">You can reset Password.</Link>
							</p>
						</Message>
					)} */}
					<Box sx={{ my: 3 }} style={{ textAlign: 'center' }}>
						<img
							src="/maytapi_full.svg"
							alt="/maytapi_full.svg"
							style={{
								width: '6rem',
								background: '#009687',
								padding: '12px',
								borderRadius: '3px',
								margin: '10px',
							}}
						/>
					</Box>
					<Box sx={{ my: 3 }} style={{ textAlign: 'center' }}>
						<Typography color="textPrimary" variant="h4">
							MAYTAPI
						</Typography>
					</Box>
					<Grid container spacing={3}>
						<Grid item xs={12} md={6}>
							<Button
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: 'rgb(0 102 178) !important',
									},
								}}
								fullWidth
								style={{ background: '#2185d0' }}
								href="/login"
								size="large"
								variant="contained"
							>
								Go to Login Page
							</Button>
						</Grid>
						{/* <Grid item xs={12} md={6}>
							<Button
								href="https://old.maytapi.com/"
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: 'rgb(0 113 101) !important',
									},
								}}
								fullWidth
								style={{ background: '#009687' }}
								size="large"
								variant="contained"
							>
								Open Old Maytapi Console
							</Button>
						</Grid> */}
					</Grid>
					<Grid container spacing={3} sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
						<Grid item xs={12} md={6}>
							<Button
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: 'rgb(0 102 178) !important',
									},
								}}
								fullWidth
								style={{ background: '#2185d0' }}
								href="/api/auth/google"
								size="large"
								variant="contained"
							>
								<GoogleIcon sx={{ mr: 0.5 }} />
								Sign up with Google
							</Button>
						</Grid>
					</Grid>
					<Box sx={{ my: 3, display: 'flex', justifyContent: 'center' }}></Box>
					<Box sx={{ my: 3 }}>
						<Typography color="textPrimary" variant="h4">
							Register Page
						</Typography>
						<Typography color="textSecondary" gutterBottom variant="body2">
							Register on the Maytapi platform
						</Typography>
					</Box>
					{props.error && (
						<Alert severity="error" margin="normal">
							{' '}
							The mail already used.
							<Typography>
								If you forget your password.
								<Link to="/login">You can reset Password.</Link>
							</Typography>
						</Alert>
					)}
					<Formik
						initialValues={{ email: '', password: '', passwordConfirmation: '', consent: false }}
						validationSchema={RegisterFormValidation}
						onSubmit={(values) => props.registerUser(values.email, values.password)}
						render={(state) => {
							return (
								<form onSubmit={state.handleSubmit}>
									<FormikInputMUI
										fullWidth
										label="Email Address"
										margin="normal"
										style={{ width: '100%', marginBottom: '8px' }}
										name="email"
										type="email"
										placeholder="Email Address"
										variant="outlined"
									/>
									<FormikInputMUI
										autoComplete="new-password"
										fullWidth
										label="Password"
										margin="normal"
										style={{ width: '100%', marginBottom: '8px' }}
										name="password"
										type="password"
										placeholder="Password"
										variant="outlined"
									/>
									<FormikInputMUI
										fullWidth
										label="Confirm Password"
										margin="normal"
										style={{ width: '100%', marginBottom: '8px' }}
										name="passwordConfirmation"
										type="password"
										placeholder="Password"
										variant="outlined"
									/>
									{/* <TextField fullWidth label="Email Address" margin="normal" name="email" type="email" variant="outlined" /> */}
									{/* <TextField fullWidth label="Password" margin="normal" name="password" type="password" variant="outlined" /> */}
									{/* <TextField
										fullWidth
										label="Confirm Password"
										margin="normal"
										name="passwordConfirmation"
										type="password"
										variant="outlined"
									/> */}
									<FormikCheckbox
										label={
											<label>
												I agree to the{' '}
												<a target="_blank" rel="noopener noreferrer" href="https://maytapi.com/legal/terms" pass>
													Terms of Service
												</a>{' '}
												and{' '}
												<a target="_blank" rel="noopener noreferrer" href="https://maytapi.com/legal/privacy">
													Privacy Policy
												</a>
											</label>
										}
										name="consent"
									/>

									<Button
										sx={{
											':hover': {
												color: '#fafafa',
												backgroundColor: 'rgb(0 102 178) !important',
											},
											margin: '15px 0 15px 0',
										}}
										fullWidth
										margin="normal"
										style={{ background: '#2185d0' }}
										size="large"
										type="submit"
										variant="contained"
									>
										Register
									</Button>
								</form>
							);
						}}
					/>
				</Container>
			</Box>
		</>
	);
};
const LoginForm = (props) => {
	if (props.userObj && props.userObj.isAuthenticated) return <Redirect to={{ pathname: '/' }} />;
	return (
		<>
			<Box
				component="main"
				sx={{
					alignItems: 'center',
					display: 'flex',
					flexGrow: 1,
					minHeight: '100%',
				}}
			>
				<Container maxWidth="sm">
					<Box sx={{ my: 3 }} style={{ textAlign: 'center' }}>
						<img
							src="/maytapi_full.svg"
							alt="/maytapi_full.svg"
							style={{
								width: '6rem',
								background: '#009687',
								padding: '12px',
								borderRadius: '3px',
								margin: '10px',
							}}
						/>
					</Box>
					<Box sx={{ my: 3 }} style={{ textAlign: 'center' }}>
						<Typography color="textPrimary" variant="h4">
							MAYTAPI
						</Typography>
					</Box>

					<Grid container spacing={3}>
						<Grid item xs={12} md={6}>
							<Button
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: 'rgb(0 102 178) !important',
									},
								}}
								fullWidth
								style={{ background: '#2185d0' }}
								href="https://chat.maytapi.com"
								size="large"
								variant="contained"
							>
								Go to Agent Login Page
							</Button>
						</Grid>
						<Grid item xs={12} md={6}>
							<Button
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: 'rgb(0 113 101) !important',
									},
								}}
								fullWidth
								style={{ background: '#009687' }}
								href="/register"
								size="large"
								variant="contained"
							>
								Go to Register Page
							</Button>
						</Grid>
					</Grid>
					<Grid container spacing={3} sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
						{/* <Grid item xs={12} md={6}>
							<Button
								href="https://old.maytapi.com/"
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: 'rgb(0 113 101) !important',
									},
								}}
								fullWidth
								style={{ background: '#009687' }}
								size="large"
								variant="contained"
							>
								Open Old Maytapi Console
							</Button>
						</Grid> */}
						<Grid item xs={12} md={6}>
							<Button
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: 'rgb(0 102 178) !important',
									},
								}}
								fullWidth
								style={{ background: '#2185d0' }}
								href="/api/auth/google"
								size="large"
								variant="contained"
							>
								<GoogleIcon sx={{ mr: 0.5 }} />
								Sign up with Google
							</Button>
						</Grid>
					</Grid>

					<Box sx={{ my: 3 }}>
						<Typography color="textPrimary" variant="h4">
							Admin Login Page
						</Typography>
						<Typography color="textSecondary" gutterBottom variant="body2">
							Sign in on the Maytapi platform
						</Typography>
					</Box>
					{props.error && (
						<Alert severity="error" margin="normal">
							This page is for only admin login.
							<br />
							The mail or password is wrong. Please double-check and try again.
						</Alert>
					)}
					<Formik
						initialValues={{ email: '', password: '' }}
						validationSchema={LoginFormValidation}
						onSubmit={(values) => {
							props.loginUser(values.email, values.password);
							profitwell('user_email', values.email);
						}}
						render={(state) => {
							return (
								<form onSubmit={state.handleSubmit} style={{ marginBottom: '15px' }}>
									<FormikInputMUI fullWidth label="Email Address" name="email" type="email" placeholder="user@mail.com" margin="normal" />
									<FormikInputMUI
										fullWidth
										label="Password"
										margin="normal"
										style={{ width: '100%', marginBottom: '8px' }}
										name="password"
										type="password"
										placeholder="Password"
									/>
									<p>
										If you forget your password.
										<Link to="/forgot"> You can reset Password.</Link>
									</p>
									<Box sx={{ py: 2 }}>
										<Button
											sx={{
												':hover': {
													color: '#fafafa',
													backgroundColor: 'rgb(0 102 178) !important',
												},
											}}
											fullWidth
											style={{ background: '#2185d0' }}
											size="large"
											type="submit"
											variant="contained"
										>
											Sign In Now
										</Button>
									</Box>
									<Typography color="textSecondary" variant="body2">
										<div>
											<a
												href="https://maytapi.com/legal/terms"
												target="_blank"
												rel="noopener noreferrer"
												style={{
													cursor: 'pointer',
												}}
											>
												Terms of Service{' '}
											</a>
											<span style={{ color: 'gray' }}>and </span>
											<a
												href="https://maytapi.com/legal/privacy"
												target="_blank"
												rel="noopener noreferrer"
												style={{
													cursor: 'pointer',
												}}
											>
												Privacy Policy
											</a>
										</div>
									</Typography>
								</form>
							);
						}}
					/>
				</Container>
			</Box>
		</>
	);
};

// const LoginForm = (props) => {
// 	if (props.userObj && props.userObj.isAuthenticated) return <Redirect to={{ pathname: '/' }} />;
// 	return (
// 		<div
// 			css={`
// 				margin-left: 20px;
// 				margin-right: 20px;
// 				display: flex;
// 				height: 100%;
// 				align-items: center;
// 				justify-content: center;
// 			`}
// 		>
// 			<div
// 				css={`
// 					max-width: 100%;
// 					width: 450px;
// 					display: flex;
// 					flex-direction: column;
// 					cd .ui.header {
// 						margin-top: 10px !important;
// 						border: 1px solid rgba(34, 36, 38, 0.15);
// 						border-radius: 0.28571429rem;
// 						padding: 12px;
// 					}
// 				`}
// 			>
// 				<div
// 					css={`
// 						display: flex;
// 					`}
// 				>
// 					<Button as={'a'} href="https://chat.maytapi.com" color="blue" compact>
// 						<Icon name="send" />
// 						Go to Agent Login Page
// 					</Button>
// 					<Button as={Link} to="/register" style={{ marginLeft: 'auto', marginRight: 0 }} color="teal" compact>
// 						Go to Register Page
// 						<Icon name="arrow right" />
// 					</Button>
// 				</div>
// 				<Header as="h2" textAlign="center">
// 					<div>Admin Login Page</div>
// 					<Image
// 						src="/maytapi_full.svg"
// 						style={{
// 							width: '6rem',
// 							background: '#009687',
// 							padding: '12px',
// 							borderRadius: '3px',
// 							margin: '10px',
// 						}}
// 					/>
// 					<div style={{ fontSize: '18px' }}>
// 						<p style={{ margin: 0 }}>Maytapi</p>
// 					</div>
// 				</Header>
// 				{props.error && <Message error header={'Login Error...'} content="The mail or password is wrong.Please double-check and try again." />}
// 				<Formik
// 					initialValues={{ email: '', password: '' }}
// 					validationSchema={LoginFormValidation}
// 					onSubmit={(values) => props.loginUser(values.email, values.password)}
// 					render={(state) => {
// 						return (
// 							<Form onSubmit={state.handleSubmit}>
// 								<TrimmedFormikInput label="Work Email" name="email" iconPosition="left" icon="mail" placeholder="user@mail.com" />
// 								<FormikInput label="Password" name="password" iconPosition="left" icon="lock" placeholder="Password" type="password" />
// 								<p>
// 									Forgot password? <Link to="/forgot">Reset password</Link>
// 								</p>
// 								<Button primary loading={props.loading === 'login'} type="submit" fluid>
// 									Login
// 								</Button>
// 								<p>
// 									<a target="_blank" rel="noopener noreferrer" href="https://maytapi.com/legal/terms">
// 										Terms of Service
// 									</a>{' '}
// 									and{' '}
// 									<a target="_blank" rel="noopener noreferrer" href="https://maytapi.com/legal/privacy">
// 										Privacy Policy.
// 									</a>
// 								</p>
// 								{/* <pre>{JSON.stringify(state, null, 2)}</pre> */}
// 							</Form>
// 						);
// 					}}
// 				/>
// 			</div>
// 		</div>
// 	);
// };

export const ForgetPasswordPage = (props) => {
	const [sending, setSending] = React.useState(false);
	const [redirect, setRedirect] = React.useState(false);
	const [err, setError] = React.useState(null);
	const handleSubmitForgot = (values) => {
		if (sending) return;
		setSending(true);
		post('/mailer/resetPassword', {
			from: 'maytapi',
			email: values.email,
		})
			.then((data) => {
				setSending(false);
				if (data.data.success) {
					setRedirect(values.email);
				} else setError(data.data.message || 'Error..!');
			})
			.catch((err) => {
				setSending(false);
				setError(err.message);
			});
	};
	if (redirect) return <Redirect to={{ pathname: '/forgot/checkyourmail', search: '?mail=' + redirect }} />;
	return (
		<Box
			component="main"
			sx={{
				alignItems: 'center',
				display: 'flex',
				flexGrow: 1,
				minHeight: '100%',
			}}
		>
			<Container maxWidth="sm">
				<Button
					sx={{
						':hover': {
							color: '#fafafa',
							backgroundColor: 'rgb(0 102 178) !important',
						},
					}}
					style={{ background: '#2185d0', marginBottom: '17px' }}
					href="/login"
					size="large"
					variant="contained"
				>
					{/* <Icon name="arrow left" /> */}
					Go to Login Page
				</Button>
				<Box
					component="main"
					sx={{
						alignItems: 'center',
						display: 'block',
						textAlign: 'center',
						flexGrow: 1,
						minHeight: '100%',
					}}
				>
					<Typography variant="h4" gutterBottom component="div">
						Forgot Password
					</Typography>
					<img
						src="/maytapi_full.svg"
						alt="/maytapi_full.svg"
						style={{
							width: '6rem',
							background: '#009687',
							padding: '12px',
							borderRadius: '3px',
							margin: '10px',
						}}
					/>
					<div style={{ fontSize: '18px' }}>
						<p style={{ margin: 0 }}>Maytapi</p>
					</div>
				</Box>
				{err && (
					<Alert severity="error">
						<AlertTitle>{err}</AlertTitle> Please try searching for your email again.
					</Alert>
				)}
				<Formik
					initialValues={{ email: '' }}
					validationSchema={ForgotFormValidation}
					onSubmit={handleSubmitForgot}
					render={(state) => {
						return (
							<form onSubmit={state.handleSubmit}>
								<FormikInputMUI
									fullWidth
									label="Work Email"
									margin="normal"
									name="email"
									type="email"
									iconPosition="left"
									variant="outlined"
									icon="mail"
									placeholder="user@mail.com"
								/>
								<Button
									type="submit"
									sx={{
										':hover': {
											color: '#fafafa',
											backgroundColor: 'rgb(0 102 178) !important',
										},
									}}
									fullWidth
									margin="normal"
									style={{ background: '#2185d0' }}
									size="large"
									variant="contained"
								>
									Send Mail
								</Button>
								{/*<pre>{JSON.stringify(state, null, 2)}</pre>*/}
							</form>
						);
					}}
				/>
			</Container>
		</Box>
	);
};

export const ResetPasswordPage = (props) => {
	const [sending, setSending] = React.useState(false);
	const [redirect, setRedirect] = React.useState(false);
	const [err, setError] = React.useState(null);
	//TODO ERROR
	const handleSubmitReset = (values) => {
		if (sending) return;
		setSending(true);
		post('/verify/resetPassword', {
			password: values.password,
			token: window.location.pathname.replace('/verify/resetPassword/', ''),
		})
			.then((data) => {
				setSending(false);
				if (data.data.success) {
					setRedirect(values.password);
				} else setError(data.data.message || 'Error..!');
			})
			.catch((err) => {
				setSending(false);
				setError(err.message);
			});
	};
	if (redirect) return <Redirect to={{ pathname: '/login' }} />;

	return (
		<Box
			component="main"
			sx={{
				alignItems: 'center',
				display: 'flex',
				flexGrow: 1,
				minHeight: '100%',
			}}
		>
			<Container maxWidth="sm">
				<Box sx={{ my: 1 }} style={{ textAlign: 'center' }}>
					<img
						src="/maytapi_full.svg"
						style={{
							width: '6rem',
							background: '#009687',
							padding: '12px',
							borderRadius: '3px',
							margin: '10px',
						}}
					/>
				</Box>
				<Box sx={{ my: 1 }} style={{ textAlign: 'center' }}>
					<Typography color="textPrimary" variant="h4">
						Reset Password
					</Typography>
				</Box>
				<Grid container spacing={3} sx={{ display: 'flex', justifyContent: 'center' }}>
					<Grid sx={{ my: 1 }} item xs={12} md={6}>
						<Button
							sx={{
								':hover': {
									color: '#fafafa',
									backgroundColor: '#2185d0 !important',
								},
							}}
							fullWidth
							style={{ background: '#2185d0' }}
							href="/api/auth/google"
							size="large"
							variant="contained"
						>
							Go to Login Page
						</Button>
					</Grid>
				</Grid>
				<Formik
					style={{ display: 'flex', flexDirection: 'column' }}
					initialValues={{ password: '', passwordConfirmation: '' }}
					validationSchema={ResetFormValidation}
					onSubmit={handleSubmitReset}
					render={(state) => {
						return (
							<form onSubmit={state.handleSubmit} style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
								<FormikInputMUI
									label="New Password"
									name="password"
									iconPosition="left"
									icon="key"
									style={{ marginBottom: '10px' }}
									placeholder="Enter new password"
									type="password"
								/>
								<FormikInputMUI
									label="Confirm"
									name="passwordConfirmation"
									iconPosition="left"
									icon="key"
									style={{ marginBottom: '10px' }}
									placeholder="Enter password again"
									type="password"
								/>
								<div>
									<p style={{ color: 'red' }}>{err}</p>
								</div>
								<Button
									sx={{
										':hover': {
											color: '#fafafa',
											backgroundColor: 'rgb(0 102 178) !important',
										},
									}}
									fullWidth
									style={{ background: '#2185d0' }}
									size="large"
									variant="contained"
									type="submit"
								>
									Change Password
								</Button>
								{/*<pre>{JSON.stringify(state, null, 2)}</pre>*/}
							</form>
						);
					}}
				/>
			</Container>
		</Box>
	);
};

export const VerifyAgent = (props) => ({});

const mapStateToProps = (state) => ({
	userObj: state.access.user,
	error: state.access.error,
	loading: state.access.loading,
});

const mapDispatchToProps = (dispatch) => ({
	getProfile: () => dispatch(getProfile()),
	logoutUser: () => dispatch(logout()),
	loginUser: (email, password) => dispatch(login(email, password)),

	toggleLogin: (newState) => dispatch(toggleLogin(newState)),
});
export const LoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginForm);

export const RegisterPage = connect(mapStateToProps, (dispatch) => ({ registerUser: (email, password) => dispatch(register(email, password)) }))(RegisterForm);
